var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.66659H1M9.66667 1.33325V3.99992M4.33333 1.33325V3.99992M4.2 14.6666H9.8C10.9201 14.6666 11.4802 14.6666 11.908 14.4486C12.2843 14.2569 12.5903 13.9509 12.782 13.5746C13 13.1467 13 12.5867 13 11.4666V5.86659C13 4.74648 13 4.18643 12.782 3.7586C12.5903 3.38228 12.2843 3.07632 11.908 2.88457C11.4802 2.66659 10.9201 2.66659 9.8 2.66659H4.2C3.0799 2.66659 2.51984 2.66659 2.09202 2.88457C1.71569 3.07632 1.40973 3.38228 1.21799 3.7586C1 4.18643 1 4.74648 1 5.86659V11.4666C1 12.5867 1 13.1467 1.21799 13.5746C1.40973 13.9509 1.71569 14.2569 2.09202 14.4486C2.51984 14.6666 3.0799 14.6666 4.2 14.6666Z",
    stroke: "#81766F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.adea873a29ba405fdc4f229ba24c1774.svg";
export { ForwardRef as ReactComponent };